<script setup lang="ts">
const props = defineProps<{
  storeId: number | null
  isSaving: boolean
}>()

const emit = defineEmits<{
  cancel: []
  confirm: []
}>()

const { t } = useI18n()

const isOpen = computed(() => props.storeId !== null)
</script>

<template>
  <AlertDialog :open="isOpen">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ t('pages.reviewPlatforms.configuration.shared.unlinkConfirmTitle') }}</AlertDialogTitle>
        <AlertDialogDescription>{{
          t('pages.reviewPlatforms.configuration.shared.unlinkConfirmDescription')
        }}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="outline" size="sm" :disabled="isSaving" @click="emit('cancel')">
          {{ t('pages.reviewPlatforms.configuration.shared.cancel') }}
        </Button>
        <Button variant="destructive" size="sm" :disabled="isSaving" @click="emit('confirm')">
          {{ t('pages.reviewPlatforms.configuration.shared.unlink') }}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
